module.exports = __webpack_public_path__ + "img/Lakes_commercial_fish_farming.3f4a3915.jpg";